
<template>
  <v-app id="searchHefc">
    <v-main>
    <v-container fluid>  
    <v-card>
      <v-card-title>Host Invoices</v-card-title>
      <v-simple-table dense>
        <thead>
           <tr>
             <th>Number</th>
             <th>Description</th>
             <th>Date / Time</th>
             <th>Host</th>
             <th>Country</th>
             <th>User</th>
           </tr>  
         </thead>
         <tbody v-for="(hefcRecord,i) in searchHefc" :key="i">
           <tr @click="$router.open('/eign/hefc/onHefc/' + hefcRecord.hefc_encrid)">
             <td>{{hefcRecord.hefc_nr}}</td>
             <td>{{hefcRecord.hefc_oms}}</td>             
             <td>{{hefcRecord.hefc_dt}}</td>
             <td>{{hefcRecord.eign_naam}}</td>
             <td>{{hefcRecord.land_code}}</td>
             <td>{{hefcRecord.gebr_code}}</td>
           </tr>  
         </tbody>  
       </v-simple-table>  
    </v-card>  
    </v-container>
    </v-main>
    <navBar title="Ares - Finance" :home="true" type="hefc"/>
  </v-app>
</template>


<script>
import navBar from "@/components/ui/navbars/navbar.vue";
 export default {
  components: {
    navBar
  },
  data() {
    return {
      searchHefc: []
    }  
  },
  mounted() {
      this.$axios
        .post("ares/json/ares/eign/hefc/searchHefc.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "searchHefc"
          },
          searchHefc: {
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.searchHefc = res.data.searchHefc;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
};

</script> 
